import { endpointPrincipal } from "../api/endPoints/endpointPrincipal/endpointPrincipal";
import { NotificacaoInterface } from "../types/NotificacaoInterface";
import { AxiosError } from "axios";

interface NotificacoesResponse {
  data: NotificacaoInterface[];
  total: number;
  totalPages: number;
}

interface PaginacaoParams {
  page?: number;
  limit?: number;
}

/**
 * Obtém todas as notificações do usuário
 */
export const obterTodasNotificacoes = async (params: PaginacaoParams = { page: 1, limit: 10 }): Promise<NotificacoesResponse> => {
  try {
    const response = await endpointPrincipal.get('/notificacoes/todas', {
      params: {
        page: params.page,
        limit: params.limit
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Obtém apenas as notificações não lidas do usuário
 */
export const obterNotificacoesNaoLidas = async (params: PaginacaoParams = { page: 1, limit: 10 }): Promise<NotificacoesResponse> => {
  try {
    const response = await endpointPrincipal.get('/notificacoes/nao-lidas', {
      params: {
        page: params.page,
        limit: params.limit
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Marca uma notificação como lida
 */
export const marcarNotificacaoComoLida = async (notificacaoId: number): Promise<NotificacaoInterface> => {
  try {
    const response = await endpointPrincipal.patch(`/notificacoes/${notificacaoId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Verifica o status do servidor de notificações
 */
export const verificarStatusNotificacoes = async (): Promise<{ status: string }> => {
  try {
    await endpointPrincipal.get('/notificacoes/status');
    return { status: 'online' };
  } catch (error: unknown) {
    if ((error as AxiosError).response) {
      // O servidor respondeu, mas com erro
      return { status: 'online_com_erro' };
    }
    return { status: 'offline' };
  }
}; 